<template>
  <!-- <div> -->
  <vs-card>
    <div class="worker">
      <div class="title">
        <h3>Manage item in Stock</h3>
      </div>
      <br />
      <div class="layout-button">
        <vs-spacer></vs-spacer>
        <!-- button onClick popup add item -->
        <vs-button @click="popupAdd = true" color="#abffa0" type="filled">
          <div class="img-btn add">
            <img src="@/assets/images/Unicorn/add_stock.gif" />
            Add
          </div>
        </vs-button>
        <vs-popup title="Add New Item in to Stock" :active.sync="popupAdd">
          <PopupAdd
            :timeStamp="timeStamp"
            v-on:close-popup-add="closePopupAdd"
          />
        </vs-popup>
        <!-- /button onClick popup add item -->

        <vs-spacer></vs-spacer>

        <!-- button onClick popup add item -->
        <vs-button @click="popupRemove = true" color="#ff634f" type="filled">
          <div class="img-btn remove">
            <img src="@/assets/images/Unicorn/out_stock.gif" />
            Remove
          </div>
        </vs-button>
        <vs-popup title="Remove Item in to Stock" :active.sync="popupRemove">
          <PopupRemove
            :timeStamp="timeStamp"
            v-on:close-popup-remove="closePopupRemove"
          />
        </vs-popup>
        <!-- /button onClick popup add item -->

        <vs-spacer></vs-spacer>
      </div>
    </div>
  </vs-card>
  <!-- </div> -->
</template>

<script>
import moment from "moment";
import PopupAdd from "./PopupAdd.vue";
import PopupRemove from "./PopupRemove.vue";

export default {
  components: {
    PopupAdd,
    PopupRemove,
  },
  data() {
    return {
      numWorker: 15,
      popupAdd: false,
      popupRemove: false,
      timeStamp: "",
      timeNow: null,
    };
  },
  mounted() {
    this.timeNow = setInterval(() => {
      this.timeStamp = moment().format("DD/MM/YYYY LTS");
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timeNow);
  },
  methods: {
    closePopupAdd(value) {
      // console.log("click close from child",value);
      this.popupAdd = value;
    },
    closePopupRemove(value) {
      // console.log("click close from child",value);
      this.popupRemove = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.worker {
  // background-color: aqua;
  // width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  .title {
    display: flex;
    gap: 10px;
  }
  .layout-button {
    display: flex;
    width: 100%;
    gap: 10px;
    justify-content: center;
    color: #abffa0;
    .img-btn {
      display: flex;
      flex-direction: column;
      font-weight: bold;
    }
      .add {
        color: #158007;
      }
      .remove {
        color: #64150b;
      }
  }
}
.input {
  width: 100%;
}
img {
  width: 150px;
}
</style>